module.exports = __webpack_public_path__ + "img/semochkin.154f8d71.jpg";